// Fixed full-screen fractal-noise paper texture. SSR-safe (static data
// URI, no browser APIs). pointer-events-none so it never traps Lenis.
export function PaperGrain() {
  return (
    <div
      className="fixed inset-0 pointer-events-none opacity-[0.035] z-0 mix-blend-multiply"
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
      }}
    />
  );
}
